import { render } from "./competence-register.vue?vue&type=template&id=2f9532ed"
import script from "./competence-register.vue?vue&type=script&lang=js"
export * from "./competence-register.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/competence/competence-register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2f9532ed"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2f9532ed', __exports__)) {
    api.reload('2f9532ed', __exports__)
  }
  
  module.hot.accept("./competence-register.vue?vue&type=template&id=2f9532ed", () => {
    api.rerender('2f9532ed', render)
  })

}


export default __exports__